/**
 * @module tree/prepend
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Content
 */

import append from './append.js'

/**
 * Adds some contents to beginning of the provided target
 * @param {Document|DocumentFragment|Element} target
 * @param {...Content} contents
 */
export default (
  target,
  ...contents
) => {
  const { childNodes } = target

  append(target, ...contents, ...childNodes)
}
